export default __webpack_public_path__ + "static/media/calendar.7af43fd4.svg";